import React from "react";
import PropTypes from "prop-types";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import history from "./history";
// import { AuthService } from "services";
import {
    App,
    AuthView,
    InboxView,
    ParticipatedView,
    CaseCreateView,
    DecisionDashboard,
    Datasheet,
    UsersAndGroupsView,
    CaseActionsView,
    UnderwritingView,
    ReportsPage,
    ReportsView,
    MpaView,
    DocumentChecklistViewPage,
    // AnchorOnBoarding,
    DistributorOnBoarding,
    NewCaseCreate,
    CaseDetailsDrawer,
    PskitCourierDetailsPage,
    CibilTable,
    AdhocCases,
    BulkUpload,
    PolicyHub,
    PaymentProgramTable,
    PaymentProgramDetailsDrawer,
    MPAApproval,
    FounderCaseDetailsDrawer
} from "pages";
import {
    SchemeDrawerView,
    DocumentChecklistCreator
} from "templates";
import Companies from "./../modules/companies";
import Lenders from "./../modules/lenders";
import BankAccounts from "./../modules/virtual-accounts";
import { AUTH_STATUS } from "constants";
import { checkAuthToken, removeAuthToken } from "utilities";
import DBOnboarding from "../templates/db-onboarding";
import AnchorOnboarding from "../templates/anchor-onboarding";
import { LeegalityPreviewNewPage } from "../modules/leegality/leegality-preview-new-page";
import FoundersCaseListing from "../templates/founders-credit-summary/case-listing-founders";
import { AuthService } from "services";
import ProtectedRoute from "./protected-route";

export { history };

class AppRouter extends React.Component {
    componentDidMount() {
        const pathname = history.location.pathname;
        const hasToken = checkAuthToken();

        if (hasToken) {
            if (pathname === "/" || pathname.includes("/auth")) {
                history.replace("/app/inbox");
            }
        } else {
            if (pathname.includes("/app")) {
                history.replace("/auth");
            }
        }

        AuthService.onStatusChange(authStatus => {
            if (
                authStatus === AUTH_STATUS.INVALID_AUTHORIZATION_CREDENTIALS ||
                authStatus === AUTH_STATUS.UNAUTHORIZED
            ) {
                removeAuthToken();
                if (history.location.pathname.includes("/app")) {
                    history.replace("/auth");
                }
            }
        });
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route
                        exact={true}
                        path="/auth"
                        render={_ => <AuthView {..._} />}
                    />
                    <Route
                        exact
                        path="/"
                        render={() => <Redirect to={"/auth"} from="/" />}
                    />
                    <Route
                        exact={false}
                        path="/app/:pageID/"
                        render={props => (
                            <App {...props}>
                                 <Route
                                path="/app/preview/document"
                                render={props => (
                                    <LeegalityPreviewNewPage {...props} />
                                )}
                            />
                                <Route
                                    path="/app/participated"
                                    render={props => (
                                        <ParticipatedView {...props} />
                                    )}
                                />
                                <Route
                                    exact={true}
                                    path="/app/inbox"
                                    render={props => <InboxView {...props} />}
                                />
                                <Route
                                    exact={true}
                                    path="/app/case/:caseId"
                                    render={props => <FounderCaseDetailsDrawer {...props} />}
                                />
                                 <Route
                                    exact={true}
                                    path="/app/cases/list/"
                                    render={props => <FoundersCaseListing {...props} />}
                                />
                                <Switch>
                                    <Route
                                        exact={true}
                                        path={"/app/:pageID/:caseId/case_checklist"}
                                        render={props => <PaymentProgramDetailsDrawer {...props} />}
                                    />
                                    <Route
                                        path={"/app/:pageID/:caseId/:tabId"}
                                        render={props => {
                                            const { pageID, caseId } = props.match.params;
                                            if (pageID === "companies" && caseId === "sync") return null;
                                            return <CaseDetailsDrawer {...props} />;
                                        }}
                                    />
                                </Switch>

                                {/* <Route
                                    path={"/app/anchor-on-boarding"}
                                    component={AnchorOnBoarding}
                                /> */}

                                <Route
                                    path={"/app/distributor-on-boarding"}
                                    component={DistributorOnBoarding}
                                />
                                <Route
                                    path={"/app/datasheet-view"}
                                    component={Datasheet}
                                />
                                <Route
                                    path={"/app/inbox/decision-dashboard/:stageId"}
                                    component={DecisionDashboard}
                                />
                                {/* <Switch> */}

                                <ProtectedRoute
                                    exact={false}
                                    path={"/app/underwriting/jobs"}
                                    component={UnderwritingView}
                                />

                                <ProtectedRoute
                                    exact={false}
                                    path={"/app/mpa-approval/"}
                                    component={MPAApproval}
                                />
                                {/* <ProtectedRoute
                                    exact={true}
                                    path={"/app/pskit-courier-details"}
                                    component={PskitCourierDetailsPage}
                                /> */}
                                {/* <ProtectedRoute
                                    exact={true}
                                    path={"/app/cibil"}
                                    component={CibilTable}
                                /> */}
                                <ProtectedRoute
                                    path={"/app/bulk-upload"}
                                    component={BulkUpload}
                                />
                                <ProtectedRoute
                                    exact={true}
                                    path={"/app/adhoc"}
                                    component={AdhocCases}
                                />
                                <ProtectedRoute
                                    path={"/app/policy-hub"}
                                    component={PolicyHub}
                                />
                                <ProtectedRoute
                                    path={"/app/payment-program/"}
                                    component={PaymentProgramTable}
                                />
                                <Switch>
                                    <ProtectedRoute
                                        path={"/app/db-onboarding/"}
                                        component={DBOnboarding}
                                    />

                                    <ProtectedRoute
                                        path={"/app/anchor-onboarding/"}
                                        component={AnchorOnboarding}
                                    />

                                </Switch>
                                {/* </Switch> */}
                                <ProtectedRoute
                                    exact={true}
                                    path={"/app/reports"}
                                    component={ReportsPage}
                                />
                                <ProtectedRoute
                                    path="/app/reports/:reportId"
                                    component={ReportsView}
                                />
                                <ProtectedRoute
                                    path="/app/companies"
                                    component={Companies}
                                />
                                <ProtectedRoute
                                    path="/app/lenders"
                                    component={Lenders}
                                />
                                <ProtectedRoute
                                    path="/app/bank-accounts"
                                    component={BankAccounts}
                                />
                                {/* <Switch>
                                    <ProtectedRoute
                                        exact={true}
                                        path={"/app/schemes"}
                                        component={MpaView}
                                    />
                                    <ProtectedRoute
                                        // exact={true}
                                        path={"/app/schemes/new"}
                                        component={SchemeDrawerView}
                                    />
                                    <ProtectedRoute
                                        // exact={true}
                                        path={"/app/schemes/:id"}
                                        component={SchemeDrawerView}
                                    />
                                </Switch> */}
                                {/* <Switch>
                                    <ProtectedRoute
                                        exact={true}
                                        path={"/app/checklist"}
                                        component={DocumentChecklistViewPage}
                                    />
                                    <ProtectedRoute
                                        // exact={true}
                                        path={"/app/checklist/new"}
                                        component={DocumentChecklistCreator}
                                    />
                                    <ProtectedRoute
                                        // exact={true}
                                        path={"/app/checklist/:id"}
                                        component={DocumentChecklistCreator}
                                    />
                                </Switch> */}
                                <Route
                                    path={"/app/inbox"}
                                    render={props => (
                                        <CaseActionsView {...props} />
                                    )}
                                />
                                <ProtectedRoute path={"/app/lenders"} component={Lenders} />
                            </App>
                        )}
                    />
                    <Redirect path="/app" to="/app/inbox" />
                </Switch>
            </Router>
        );
    }
}

AppRouter.propTypes = {
    history: PropTypes.object,
    store: PropTypes.object
};

export default AppRouter;
